import { ReactElement, useEffect, useState } from "react";
import { Layout, Button, Row, Col, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import firebase from "firebase/app";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { getAuthState } from "../../redux/selectors";
import BookingDetail from "../../components/BookingDetail";
import api from "../../redux/api/axiosInstance";
import { SET_LOADING_STATE, RESET_LOADING_STATE } from "../../redux/constants";

const { Content } = Layout;

export function UserDashboard(): ReactElement {
  const history = useHistory();
  const { currentUser } = useSelector(getAuthState);
  const [bookings, setBookings] = useState<any[]>([]);
  const [upcomingBookings, setUpcomingBookings] = useState<any[]>([]);
  const [pastBookings, setPastBookings] = useState<any[]>([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const subscribe = firebase.firestore()
      .collection("bookings")
      .where("userId", "==", currentUser?.id)
      .where("status", "!=", "cancelled")
      .orderBy("status", "asc")
      .orderBy("date", "desc")
      .orderBy("start", "desc")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const data = change.doc.data();
            const now = moment();
            const bookingDateTime = moment(`${data.date} ${data.start}`);
            if (now > bookingDateTime) setPastBookings(origin => [...origin, data]);
            else setUpcomingBookings(origin => [...origin, data]);
          }
          if (change.type === "modified") {
            console.log("Modified");
          }
          if (change.type === "removed") {
            console.log("Removed");
            setBookings(origin => origin.filter(b => b.bookingId !== change.doc.data().bookingId));
          }
        });
      })
    return () => subscribe();
  }, []);

  const cancelBooking = (book: any) => {
    dispatch({ type: SET_LOADING_STATE });

    const { bookingId } = book;
    const confirm = window.confirm(t("are_you_sure"));
    if (!confirm) return;
    api.post("/cancel_booking", { bookingId })
      .then(() => {
        setUpcomingBookings(origin => origin.filter(booking => booking.bookingId !== bookingId));
        message.success(t('booking.remove_success'));
        dispatch({ type: RESET_LOADING_STATE });
      })
      .catch(e => {
        console.log("Error", e);
        message.error(t('error.request_error'));
        dispatch({ type: RESET_LOADING_STATE });
      })
  };

  return (
    <Content>
      <Row gutter={{ sm: 8, md: 16 }}>
        {
          upcomingBookings.length > 0 && <Col xs={24}>
            <h4 className="user-booking-history-tag-label">Upcoming Bookings</h4>
          </Col>
        }

        {upcomingBookings.map((b) => (
          <Col xs={24} sm={12} md={6} xl={4} style={{ marginTop: 10 }} key={b.bookingId}>
            <BookingDetail book={b} onCancel={cancelBooking} />
          </Col>
        ))}
      </Row>
      <Row gutter={{ sm: 8, md: 16 }} style={{ marginTop: 20 }}>
        <Col xs={24}>
          <h4 className="user-booking-history-tag-label">Past Bookings</h4>
        </Col>
        {pastBookings.map((b) => (
          <Col xs={24} sm={12} md={6} xl={4} style={{ marginTop: 10 }} key={b.bookingId}>
            <BookingDetail book={b} onCancel={cancelBooking} />
          </Col>
        ))}
      </Row>
      <Button
        type="primary"
        style={{ position: "fixed", right: 25, bottom: 25, width: 60, height: 60, borderRadius: 30 }}
        icon={<PlusOutlined style={{ fontSize: 20 }} />}
        onClick={() => history.push("/booking")}
      />
    </Content>
  );
}
